
import Header from '../../components/feature/Header';

const AcceleratorPlaybookPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative bg-slate-900 py-32 bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(15, 23, 42, 0.9), rgba(15, 23, 42, 0.9)), url('https://public.readdy.ai/ai/img_res/e2550d78787b02d18c856966924022eb.jpg')`
        }}
      >
        <div className="max-w-6xl mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6" style={{ fontFamily: '"Playfair Display", serif' }}>
            ACCELERATOR PLAYBOOK
          </h1>
          <p className="text-xl text-gray-300 max-w-4xl mx-auto leading-relaxed">
            Where capital meets execution. Our custom-built growth engine designed exclusively 
            for European startups entering the Latin American market.
          </p>
        </div>
      </section>

      {/* Introduction Section */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6" style={{ fontFamily: '"Playfair Display", serif' }}>
              Real Growth Happens When Capital Meets Execution
            </h2>
            <p className="text-xl text-gray-700 max-w-4xl mx-auto leading-relaxed">
              Our Accelerator Playbook isn't a one-size-fits-all program — it's a custom-built growth engine 
              designed exclusively for European startups entering the Latin American market.
            </p>
          </div>
        </div>
      </section>

      {/* Process Overview */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            <div className="text-center">
              <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-search-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-2">Screening</h3>
              <p className="text-gray-600">Rigorous evaluation through our "Pitch Us" process</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-pulse-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-2">Diagnostic</h3>
              <p className="text-gray-600">AI-driven analysis with 30+ years banking expertise</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-rocket-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-2">Acceleration</h3>
              <p className="text-gray-600">Custom playbook with hands-on operational partnership</p>
            </div>
          </div>
        </div>
      </section>

      {/* Entry Criteria Section */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <div className="bg-gradient-to-r from-slate-50 to-gray-50 p-8 md:p-12 rounded-2xl shadow-sm border border-gray-100">
            <div className="flex items-center mb-8">
              <div className="w-12 h-12 bg-red-600 rounded-lg flex items-center justify-center mr-4">
                <i className="ri-filter-3-line text-xl text-white"></i>
              </div>
              <h2 className="text-3xl font-bold text-slate-900" style={{ fontFamily: '"Playfair Display", serif' }}>
                Entry Criteria: "Pitch Us" Screening
              </h2>
            </div>
            
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              Participation in the Accelerator Playbook begins only after a successful diagnostic screening, 
              conducted post our "Pitch Us" submission process. Our founding team personally reviews every 
              application and evaluates it based on:
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="flex items-start">
                <div className="w-2 h-2 bg-red-600 rounded-full mt-3 mr-4 flex-shrink-0"></div>
                <div>
                  <h4 className="font-semibold text-slate-900 mb-1">Financial Viability</h4>
                  <p className="text-gray-600">Runway analysis and capital efficiency assessment</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="w-2 h-2 bg-red-600 rounded-full mt-3 mr-4 flex-shrink-0"></div>
                <div>
                  <h4 className="font-semibold text-slate-900 mb-1">Product Demo</h4>
                  <p className="text-gray-600">Scalability potential and technical foundation</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="w-2 h-2 bg-red-600 rounded-full mt-3 mr-4 flex-shrink-0"></div>
                <div>
                  <h4 className="font-semibold text-slate-900 mb-1">Vision Clarity</h4>
                  <p className="text-gray-600">Team alignment and strategic direction</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="w-2 h-2 bg-red-600 rounded-full mt-3 mr-4 flex-shrink-0"></div>
                <div>
                  <h4 className="font-semibold text-slate-900 mb-1">Market Fit</h4>
                  <p className="text-gray-600">Founder-market fit and LATAM relevance</p>
                </div>
              </div>
            </div>
            
            <div className="mt-8 p-6 bg-white rounded-lg border border-gray-200">
              <p className="text-slate-900 font-medium text-center">
                Only the strongest and most strategically aligned startups move forward into the diagnostic phase.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Diagnostic Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-6xl mx-auto px-6">
          <div className="bg-gradient-to-r from-indigo-50 to-blue-50 p-8 md:p-12 rounded-2xl shadow-sm border border-indigo-100">
            <div className="flex items-center mb-8">
              <div className="w-12 h-12 bg-indigo-600 rounded-lg flex items-center justify-center mr-4">
                <i className="ri-brain-line text-xl text-white"></i>
              </div>
              <h2 className="text-3xl font-bold text-slate-900" style={{ fontFamily: '"Playfair Display", serif' }}>
                The EULA VC Diagnostic
              </h2>
            </div>
            
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              Once selected, we conduct a front-to-back diagnostic using a proprietary mix of AI-driven 
              analysis tools and our internal banking frameworks — developed from over 30 years of combined 
              experience in LATAM banking, investment, and corporate strategy.
            </p>
            
            <div className="bg-white p-6 rounded-lg border border-indigo-200 mb-8">
              <h4 className="font-semibold text-slate-900 mb-4">
                This diagnostic allows us to pinpoint the startup's key accelerants and bottlenecks across:
              </h4>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="flex items-center">
                  <i className="ri-money-dollar-circle-line text-indigo-600 mr-3"></i>
                  <span className="text-gray-700">Financial structure and capitalization strategy</span>
                </div>
                
                <div className="flex items-center">
                  <i className="ri-global-line text-indigo-600 mr-3"></i>
                  <span className="text-gray-700">Market entry readiness and regulatory alignment</span>
                </div>
                
                <div className="flex items-center">
                  <i className="ri-global-line text-indigo-600 mr-3"></i>
                  <span className="text-gray-700">Product-market fit in target LATAM geography</span>
                </div>
                
                <div className="flex items-center">
                  <i className="ri-team-line text-indigo-600 mr-3"></i>
                  <span className="text-gray-700">Team structure, hiring roadmap, and governance</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Accelerator Playbook Section */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <div className="bg-gradient-to-r from-teal-50 to-green-50 p-8 md:p-12 rounded-2xl shadow-sm border border-teal-100">
            <div className="flex items-center mb-8">
              <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center mr-4">
                <i className="ri-book-open-line text-xl text-white"></i>
              </div>
              <h2 className="text-3xl font-bold text-slate-900" style={{ fontFamily: '"Playfair Display", serif' }}>
                The Accelerator Playbook
              </h2>
            </div>
            
            <div className="space-y-6">
              <p className="text-lg text-gray-700 leading-relaxed">
                The EULA VC Accelerator Playbook is then custom-built based on the diagnostic results. 
                There's no template. No "standard mentorship." Instead, we provide hands-on operational 
                partnership tailored to the founder's specific industry, product, and market of entry.
              </p>
              
              <div className="bg-white p-6 rounded-lg border border-teal-200">
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-teal-600 rounded-full flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                    <i className="ri-shield-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-slate-900 mb-2">Our "No-Bullshit Approach"</h4>
                    <p className="text-gray-700 leading-relaxed">
                      A practical, all-hands-on-deck format where our senior partners work side-by-side 
                      with founders to build the right market strategy, select the ideal entry countries, 
                      and structure the local team for scalable success.
                    </p>
                  </div>
                </div>
              </div>
              
              <div className="bg-white p-6 rounded-lg border border-teal-200">
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-teal-600 rounded-full flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                    <i className="ri-trophy-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-slate-900 mb-2">Our Goal is Simple</h4>
                    <p className="text-gray-700 leading-relaxed">
                      To help European founders enter LATAM with confidence, avoid common expansion pitfalls, 
                      and scale their customer base and EBITDA faster through data-driven, experience-backed 
                      decision making.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-slate-900">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" style={{ fontFamily: '"Playfair Display", serif' }}>
            Ready to Accelerate Your LATAM Expansion?
          </h2>
          <p className="text-xl text-gray-300 mb-8 leading-relaxed">
            Start your journey with our diagnostic screening process. Submit your pitch and let's build 
            your custom growth engine together.
          </p>
          <a 
            href="/pitch"
            className="inline-flex items-center px-8 py-4 bg-teal-600 text-white font-semibold rounded-lg hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            Submit Your Pitch
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
      </section>
    </div>
  );
};

export default AcceleratorPlaybookPage;
